export default "__VITE_ASSET__BgJlZ9Wo__"